module.exports = __webpack_public_path__ + "static/media/mobileScreenshot08.49212ac4.jpg";